module.exports = __webpack_public_path__ + "static/media/signup_background.2919ea18.png";